<template>
  <div>
    <b-row align-h="between">
      <b-col cols="6"
        ><b-button-group size="md">
          <b-button
            class="mr-2"
            variant="outline-success"
            @click="fromLoad('add')"
            v-if="allow('A')"
          >
            <b-icon-plus></b-icon-plus>
            {{ $l("tips_add") || "新增属性" }}
          </b-button>
        </b-button-group>
      </b-col>
      <b-col cols="6">
        <b-form onsubmit="return false">
          <b-input-group>
            <b-form-input
              v-model="form.searchKey"
              type="search"
              placeholder="Search here..."
              @keyup.enter="query"
            />
            <b-input-group-append>
              <b-button-group>
                <b-button @click="query" variant="primary" class="my-2 my-sm-0">
                  <i class="fa fa-search"></i>
                </b-button>
                <b-dropdown right variant="light" ref="dropdown">
                  <b-dd-form :inline="true" style="width: 400px">
                    <b-form-row>
                      <b-col cols="12">
                        <b-form-group label="状态">
                          <b-form-checkbox-group
                            style="width: 100%"
                            id="checkbox-group-2"
                            v-model="form.fabricAttrStatusList"
                          >
                            <b-form-checkbox value="Y">可用</b-form-checkbox>
                            <b-form-checkbox value="N">不可用</b-form-checkbox>
                          </b-form-checkbox-group>
                        </b-form-group>
                      </b-col>
                    </b-form-row>
                    <b-form-row>
                      <b-col class="mt-2" style="text-align: center">
                        <b-button block variant="primary" @click="query"
                          >Search</b-button
                        >
                        <b-button
                          block
                          variant="outline-primary"
                          @click="onReset"
                          >Reset</b-button
                        >
                      </b-col>
                    </b-form-row>
                  </b-dd-form>
                </b-dropdown>
              </b-button-group>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      form: {
        searchKey: "",
        fabricAttrTypeEn: "",
        fabricAttrStatusList: ["Y"],
      },
    };
  },
  methods: {
    fromLoad(val) {
      this.$emit(val);
    },
    assign(form) {
      this.form = { ...this.form, ...form };
    },
    query() {
      this.$emit("submit", this.form);
    },
    onReset() {
      this.form = {
        searchKey: "",
        fabricAttrTypeEn: "",
        fabricAttrStatusList: ["Y"],
      };
      this.$emit("reset");
      this.$emit("submit", this.form);
    },
  },
  mounted() {
    this.$emit("loadLeftData");
    this.onReset();
  },
  activated() {
    this.$emit("loadLeftData");
    this.onReset();
  },
};
</script>

